// eslint-disable-next-line prefer-template
// eslint-disable-no-nested-ternary

const setToken = ({ token }) => localStorage.setItem('token', token);

const setUserData = (data) =>
  localStorage.setItem('user', JSON.stringify(data.user));

const setPhoneNumber = (phoneNumber) =>
  localStorage.setItem('phoneNumber', phoneNumber);

const setSpecificUserData = (key, data) =>
  localStorage.setItem(key, JSON.stringify(data));

const getToken = () => localStorage.getItem('token');

const getUserData = () => JSON.parse(localStorage.getItem('user'));

const getSpecificUserData = (key) => JSON.parse(localStorage.getItem(key));

const emailValidator = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const numberValidator = (number) => {
  const re = /[+-]?([0-9]*[.])?[0-9]+/;
  return re.test(String(number));
};

const getFullName = (user) =>
  user.name
    ? user.name
    : user.customer_name
    ? user.ReportersName
    : user.ReportersName
    ? user.customer_name
    : user.user
    ? `${user.user.firstName} ${user.user.lastName || user.user.surname}`
    : `${user.firstName} ${user.lastName || user.surname}`;

const clearStorage = () => {
  const localAdmins = localStorage.getItem('waya_cms_local_admins');
  localStorage.clear();
  if (localAdmins) {
    localStorage.setItem('waya_cms_local_admins', localAdmins);
  }
};
const addLight = (color, amount) => {
  const cc = parseInt(color, 16) + amount;
  let c = cc > 255 ? 255 : cc;
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
  return c;
};

/* const hexToRGB = (color) => {
  color = (color.indexOf("#")>=0) ? color.substring(1,color.length) : color;
  let colorRGB = [color.substring(0,2)]
} */

const subtractLight = (color, amount) => {
  const cc = parseInt(color, 16) - amount;
  let c = cc < 0 ? 0 : cc;
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
  return c;
};

const lightenColor = (color, amount) => {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt((255 * amount) / 100, 10);
  return (color = `#${addLight(color.substring(0, 2), amount)}${addLight(
    color.substring(2, 4),
    amount
  )}${addLight(color.substring(4, 6), amount)}`);
};

const darkenColor = (color, amount) => {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt((255 * amount) / 100, 10);
  return (color = `#${subtractLight(
    color.substring(0, 2),
    amount
  )}${subtractLight(color.substring(2, 4), amount)}${subtractLight(
    color.substring(4, 6),
    amount
  )}`);
};

const formatPhoneNumber = (phone) => {
  const phoneNum = phone;
  if (
    phoneNum?.startsWith('234') ||
    phoneNum?.startsWith('+234') ||
    phoneNum === ''
  ) {
    return phoneNum;
  }
  const start = '+234';
  const phoneNumber = phoneNum?.substring(1);
  return `${start}${phoneNumber}`;
};

function currencyFormat(num) {
  return `₦${num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
}

export {
  setToken,
  getToken,
  setUserData,
  setPhoneNumber,
  setSpecificUserData,
  getUserData,
  getSpecificUserData,
  emailValidator,
  numberValidator,
  getFullName,
  clearStorage,
  lightenColor,
  darkenColor,
  formatPhoneNumber,
  currencyFormat,
};
